import { useState } from "react";
import QuillEditor, { Quill } from "react-quill";
import ImageCompress from 'quill-image-compress';
import "react-quill/dist/quill.snow.css";
import './index.css'

Quill.register('modules/imageCompress', ImageCompress);

let modules = {
  imageCompress: {
    parchment: Quill.import('parchment'),
    modules: ['Resize', 'DisplaySize'],
    quality: 1, 
    maxWidth: 1600, 
    maxHeight: 1600,
  }
}

export default function RichEditor({ name, value, handleChange, disabled = false }: any) {
  const [currentValue, setCurrentValue] = useState(value)
  let event: any = { target: { name: name, value: undefined } }


  const setValue = (v: any) => {
    if (!disabled) {
      event.target.value = v
      setCurrentValue(v)
      handleChange(event)
    }
  }

  return (
    <div id="richtext-editor" className={`richtext-editor${disabled ? ' richtext-editor__disabled' : ''}`}>
      <QuillEditor
        modules={modules}
        theme="snow"
        value={disabled ? value : currentValue}
        onChange={(v) => setValue(v)}
        readOnly={disabled}
      />
    </div>
  );
};
